import { Switch as SwitchPrimitive } from 'radix-ui';
import { cn } from '../../lib/cn';

export interface SwitchProps {
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: (checked: boolean) => void;
  /** Für Screenreader; den sichtbaren Text liefert der Aufrufer (meist SettingRow). */
  label?: string;
  disabled?: boolean;
  id?: string;
  className?: string;
}

/** An/Aus für Einstellungen, die sofort gelten. Was erst mit „Speichern“ gilt, ist eine Checkbox. */
export function Switch({ checked, defaultChecked, onChange, label, disabled, id, className }: SwitchProps) {
  return (
    <SwitchPrimitive.Root
      id={id}
      checked={checked}
      defaultChecked={defaultChecked}
      onCheckedChange={onChange}
      aria-label={label}
      disabled={disabled}
      className={cn(
        'inline-flex h-6 w-10 shrink-0 cursor-pointer items-center rounded-full bg-input p-[3px] transition-colors duration-150 data-[state=checked]:bg-selection disabled:cursor-not-allowed disabled:opacity-45',
        className,
      )}
    >
      <SwitchPrimitive.Thumb className="block size-[18px] rounded-full bg-knob shadow-sm transition-transform duration-[180ms] ease-out data-[state=checked]:translate-x-4" />
    </SwitchPrimitive.Root>
  );
}
